import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { ExternalFileViewerPanelComponent } from './lib/external-file-viewer-panel.component'
import { ExternalFileViewerKey } from './panel-key'

export * from './lib/external-file-viewer.module'
export * from './panel-key'

export const ExternalFileViewerPanelConfig: PanelConfig = {
  key: ExternalFileViewerKey,
  title: 'External File Viewer',
  description:
    'Investigate reconciliation differences using external transaction and position files.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: ExternalFileViewerPanelComponent,
  accessPermission: 'accessExternalFileViewerPanel',
}
